<template>
  <div class="col-9 p-4 h-100 overflow-auto">
    <div class="w-75 m-auto d-flex flex-column">
      <form-input
        v-model="form.id.value"
        :error="form.id.error"
        :label="$t('admin.companyEdit.form.id.label')"
        readonly
        @input="onNameInput"
      />
      <form-input
        v-model="form.name.value"
        :error="form.name.error"
        :label="$t('admin.companyEdit.form.name.label')"
        :placeholder="$t('admin.companyEdit.form.name.placeholder')"
        required
        @input="onNameInput"
      />

      <form-datetimepicker
        v-model="form.activateTime.value"
        :error="form.activateTime.error"
        :label="$t('admin.companyEdit.form.activateTime.label')"
      />
      <form-datetimepicker
        v-model="form.expireTime.value"
        :error="form.expireTime.error"
        :label="$t('admin.companyEdit.form.expireTime.label')"
      />
    </div>
  </div>
</template>

<script>
import Input from '@/components/FormModule/Input.vue';
import DatetimePicker from '@/components/FormModule/DatetimePicker.vue';

export default {
  components: {
    'form-input': Input,
    'form-datetimepicker': DatetimePicker
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: this.value
    };
  },
  computed: {
  },
  watch: {
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true
    },
    form: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    onNameInput() {

    }
  }
};
</script>
